export enum SedsFormFieldType {
  AUTOCOMPLETE = 'autocomplete',
  BASIC = 'basic',
  DATEPICKER = 'datepicker',
  DROPDOWN = 'dropdown',
  NUMBER = 'number',
  SELECT = 'select',
  TEXT = 'text',
  TEXTAREA = 'textarea',
  SEARCH = 'search',
}
